import {Component, OnInit, AfterViewInit, EventEmitter, ViewChild, Output, ElementRef } from '@angular/core';
import { AnimationEvent } from '@angular/animations';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import { animationTranslateBottomTop, animationOpacity } from '../../dashboard-module/utils/animations/animations';
import { AuthService } from 'src/app/auth.service';
import { Channel } from '../signup/signup.component';
import { AccountVerificationService } from 'src/app/account-verification.service';
import {LoginModel} from '../login/login.model';
import {HttpErrorResponse, HttpStatusCode} from '@angular/common/http';
import {UserIntegrityService} from '../../user-integrity.service';

@Component({
    selector: 'app-sms-verification',
    templateUrl: './sms-verification.component.html',
    styleUrls: ['./sms-verification.component.scss'],
    animations: [animationTranslateBottomTop, animationOpacity],
    host: {
        class: 'sms-verification-container',
        '[@state]': '_animationState',
        '(@state.start)': '_onAnimationStart($event)',
        '(@state.done)': '_onAnimationDone($event)'
    },
})
export class SmsVerificationComponent implements OnInit, AfterViewInit {
    _animationState: 'void' | 'visible' | 'showing' | 'hidden' = 'void';
    animationTimerEnd: 'void' | 'visible' | 'showing' | 'hidden' = 'void';
    animationSMSResended: 'void' | 'visible' | 'showing' | 'hidden' = 'void';

    @Output() animationStateChanged = new EventEmitter<AnimationEvent>();
    @Output() userActivation = new EventEmitter<any>();

    @Output() userHasVerifiedCode = new EventEmitter<boolean>();

    typeOfVerification: 'non-signup' | 'signup' = 'signup';
    data = '52';
    isForReset = false;

    userId: number = null;
    channel = '';
    country: 'mexico' | 'usa' = 'mexico';
    componentState:
        | 'initial'
        | 'codeOk'
        | 'codeError'
        | 'timerEnd'
        | 'resendingCode' = 'initial';
    animationCodeDescOk: 'void' | 'visible' | 'showing' | 'hidden' = 'void';
    animationBtnOk: 'void' | 'visible' | 'showing' | 'hidden' = 'visible';

    counter = 60000;
    counterInterval: any;
    loadingResendSMS: boolean;
    loadingSendCode: boolean;

    resetForm: FormGroup;

    @ViewChild('resetContainer', {})
    viewElementRef: ElementRef<any>;

    constructor(
        private authService: AuthService,
        private accountVerificationService: AccountVerificationService,
        private userIntegrityService: UserIntegrityService,
    ) {}

    ngOnInit() {
        this.resetForm = new FormGroup({
            codeNumber: new FormControl('', [Validators.required, Validators.minLength(6)])
        });
    }

    timerStart() {
        console.log('Started timer');
        this.counter = 60000;
        this.counterInterval = setInterval(() => {
            this.counter -= 1000;

            if (this.counter === 0) {
                this.onTimerEnd();
                clearInterval(this.counterInterval);
            }
        }, 1000);
    }

    ngAfterViewInit() {}

    _onAnimationStart(event: AnimationEvent) {
        this.animationStateChanged.emit(event);
    }

    /**
    *   @param data - Settings for verification component
    *   @param data.id - User ID to verify
    *   @param data.account - User email/Phone number to verify
    *   @param data.channel - This data is used to check type of account (Internal use only)
    *   @param data.state - This data is used to setup view according to current flow state (Internal use only)
    *   @param data.typeOfVerification - This data is used to determine which actions need to be launched
    *
    */
    public open( data: {
        id: number | null,
        account: string;
        channel: Channel;
        state: 'sendingCode' | 'resendingCode';
        typeOfVerification: 'non-signup' | 'signup';
        isForReset: boolean;
    }) {
        this.userId = data.id;

        this.onOpenedDialog(data);
    }

    private onOpenedDialog(data: any): void {
        const { account, channel, state, typeOfVerification, isForReset } = data;

        this.timerStart();

        if (state === 'resendingCode') {
            this.componentState = 'resendingCode';
        }

        this.channel = channel;
        this.country = this.getCountryByNumber(account);
        this.data = account;
        this.typeOfVerification = typeOfVerification;
        this.isForReset = isForReset;
        this._animationState = 'showing';

        setTimeout(() => {
            this._animationState = 'visible';
        }, 10);
    }

    getCountryByNumber(data: string): 'mexico' | 'usa' {
        const countryCode = data.slice(0, 2);
        if (countryCode === '52') {
            return 'mexico';
        } else {
            return 'usa';
        }
    }

    public close() {
        this.resetForm.reset();
        this._animationState = 'hidden';
    }

    _onAnimationDone(event: AnimationEvent) {
        // if (event.toState === 'hidden') {
            // this._restoreFocus();
        // } else if (event.toState === 'visible') {
            // this._trapFocus();
        // }

        this.animationStateChanged.emit(event);
    }

    sendCode(): void {
        const code = this.resetForm.get('codeNumber').value;

        this.loadingSendCode = true;

        if (this.typeOfVerification === 'signup') {
            const payload: LoginModel = {
                account: this.data,
                password: code,
                pass_type: 4
            };

            this.authService.login(payload).subscribe(
                (response) => {
                    const { data } = response;
                    const { codigo } = data;

                    if (codigo === 0) {
                        this.saveUserDataInStorage(data);
                        this.userIntegrityService.checkNow();
                    }
                },
                (err: HttpErrorResponse) => {
                    const { status } = err;

                    if (status === HttpStatusCode.Unauthorized) {
                        this.resetForm.get('codeNumber').setErrors({ invalidCredentials: true });
                    }
                }
            );
            return;
        }

        this.authService.validateVerificationCode(this.userId, this.data, code)
            .subscribe(
                response => this.onSuccessSendedCode(response),
                err => this.onErrorSendedCode(err)
            );
    }

    public resendCodeSMS(account: string): void {
        this.loadingResendSMS = true;

        clearInterval(this.counterInterval);

        this.accountVerificationService.sendRecoveryCode(account, this.channel, this.userId).subscribe(
            () => {
                this.resetForm.reset();
                this.onSendCode();
                this.timerStart();
                this.loadingResendSMS = false;
            },
            () => {
                this.loadingResendSMS = false;
            }
        );
    }

    private onSuccessSendedCode(response: any): void {
        this.smsCodeVerificationRes(response);
    }

    private onErrorSendedCode(err: any): void {
        this.loadingSendCode = false;
        // this.snackbar.open(err.error.message, 'CERRAR', {
        //     duration: 5000
        // });
        this.resetForm.get('codeNumber').setErrors({ invalidCode: true });
    }

    onTimerEnd() {
        this.componentState = 'timerEnd';

        this.animationTimerEnd = 'showing';
        setTimeout(() => {
            this.animationTimerEnd = 'visible';
        }, 10);
    }

    onSendCode() {
        this.componentState = 'initial';

        // this.animationTimerEnd = 'showing';
        setTimeout(() => {
            this.animationTimerEnd = 'hidden';
        }, 10);

        this.animationSMSResended = 'showing';

        setTimeout(() => {
            this.animationSMSResended = 'visible';
        }, 10);

        setTimeout(() => {
            this.animationSMSResended = 'hidden';
        }, 10000);
    }

    resetComponent() {
        this.userActivation.emit(-1);
        this._animationState = 'hidden';
        this.animationBtnOk = 'visible';
        this.onTimerEnd();
        this.resetForm.reset();
    }

    onCodeOk() {
        setTimeout(() => {
            this.resetComponent();
            this.userHasVerifiedCode.emit(true);
        }, 3000);

        // Show Code Ok animation
        this.componentState = 'codeOk';
        this.animationCodeDescOk = 'showing';
        this.animationBtnOk = 'hidden';

        setTimeout(() => {
            this.animationCodeDescOk = 'visible';
        }, 10);
    }

    smsCodeVerificationRes(res: any) {
        this.loadingSendCode = false;

        console.log(res);

        if (res.data.codigo === 0) {
            this.onCodeOk();
        } else {
            this.resetForm.setErrors({ invalidCode: true });
        }
    }

    smsCodeVerificationErr(err: any) {}

    private saveUserDataInStorage(response: any): void {
        const { id_usu, multiempresa, empresa, tipologin, sw_req_pass, email } = response;
        const loginType = (tipologin) ? tipologin : 't';
        const reqPass = (sw_req_pass) ? sw_req_pass.toString() : '0';

        localStorage.setItem('user_id', id_usu);
        localStorage.setItem('user_enterprise_id', empresa);
        localStorage.setItem('user_multi_enterprise', multiempresa);
        localStorage.setItem('user_account', email);
        localStorage.setItem('cw_sess_st', 'ok');
        localStorage.setItem('userType', loginType.trim().toLocaleLowerCase());
        localStorage.setItem('require_pwd_in_link', reqPass);
    }
}
